/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ListIssuesForViewer_viewer = {
    readonly id: string;
    readonly issuesForViewer: {
        readonly pageInfo: {
            readonly hasNextPage: boolean;
            readonly endCursor: string | null;
        };
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly description: string;
                readonly frame: {
                    readonly id: string;
                } | null;
                readonly " $fragmentRefs": FragmentRefs<"LabelingIssueListItem_issue">;
            } | null;
        } | null>;
    };
    readonly " $refType": "ListIssuesForViewer_viewer";
};
export type ListIssuesForViewer_viewer$data = ListIssuesForViewer_viewer;
export type ListIssuesForViewer_viewer$key = {
    readonly " $data"?: ListIssuesForViewer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ListIssuesForViewer_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "ListIssuesForViewer_viewer",
  "type": "Viewer",
  "metadata": {
    "connection": [
      {
        "count": "countIssuesForViewer",
        "cursor": null,
        "direction": "forward",
        "path": [
          "issuesForViewer"
        ]
      }
    ]
  },
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "countIssuesForViewer",
      "type": "Int",
      "defaultValue": 15
    },
    {
      "kind": "LocalArgument",
      "name": "onlyForViewer",
      "type": "Boolean",
      "defaultValue": true
    }
  ],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": "issuesForViewer",
      "name": "__ListIssuesForViewer_issuesForViewer_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "LabelingIssueConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pageInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "PageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "LabelingIssueEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "LabelingIssue",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "frame",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Frame",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/)
                  ]
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "__typename",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "FragmentSpread",
                  "name": "LabelingIssueListItem_issue",
                  "args": null
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = '02f6b604e3a42ceec55f1313078dae79';
export default node;
